import { NgModule } from '@angular/core';
import { LogSubmitTabsComponent } from 'components/modal-windows/step-details/log-details/modal-content/submit-tabs/submit-tabs.component';
import { FileUploadModule } from '@certemy/ui-components';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DynamicFormModule } from 'components/dynamic-form/dynamic-form.module';
import { InlineErrorModule } from 'components/errors/inline-error.module';

@NgModule({
  imports: [CertemyCommonModule, FileUploadModule, NgbModule, DynamicFormModule, InlineErrorModule],
  exports: [LogSubmitTabsComponent],
  declarations: [LogSubmitTabsComponent],
})
export class LogSubmitTabsModule {}
